import { formatUtcTimeRange, formatDisplayTime } from './date'
import { getDonorEligibilityForScheduleRow } from './procedure-eligibility'

/**
 * Sum of `available_slots_count` from donor-center-calendar rows.
 * Backend excludes elapsed slots via `sqlShiftsSlotStartInFuture` in the
 * donor-center-calendar query (same idea as drive/session scheduling).
 */
export const sumRowsAvailableSlots = rows => {
  if (!Array.isArray(rows)) return 0
  return rows.reduce((sum, row) => {
    const raw = row?.available_slots_count
    const n = raw == null || raw === '' ? 0 : Number(raw)
    return sum + (Number.isNaN(n) ? 0 : Math.max(0, n))
  }, 0)
}

/**
 * First session row on that day with slots > 0 and donor eligibility (when logged in).
 */
export const pickFirstBookableSessionRow = (
  events,
  dateStr,
  { donor, procedureFilter }
) => {
  const sorted = [...(events || [])].sort((a, b) =>
    String(a.start_time || '').localeCompare(String(b.start_time || ''))
  )

  for (const row of sorted) {
    const slots = Number(row?.available_slots_count)
    if (Number.isNaN(slots) || slots <= 0) continue

    const { selectable } = getDonorEligibilityForScheduleRow({
      donorId: donor?.id,
      procedureEligibilities: donor?.procedure_eligibilities,
      selectedProcedureTypeId: procedureFilter,
      appointmentDayIso: dateStr,
      procedureTypesOnRow: row?.procedure_types,
    })
    if (!selectable) continue

    return row
  }

  return null
}

/** Aggregate time span across session rows for a single calendar day. */
export const formatDaySessionsTimeSpan = events => {
  if (!events?.length) return ''
  let minStart = null
  let maxEnd = null
  for (const e of events) {
    if (e.start_time) {
      const t = new Date(e.start_time).getTime()
      if (!Number.isNaN(t))
        minStart = minStart === null ? t : Math.min(minStart, t)
    }
    if (e.end_time) {
      const t = new Date(e.end_time).getTime()
      if (!Number.isNaN(t)) maxEnd = maxEnd === null ? t : Math.max(maxEnd, t)
    }
  }
  if (minStart === null) return ''
  const startIso = new Date(minStart).toISOString()
  if (maxEnd === null) {
    return formatDisplayTime(startIso, 'hh:mm a')
  }
  const endIso = new Date(maxEnd).toISOString()
  return formatUtcTimeRange(startIso, endIso)
}
